<template>
  <section v-lenis-scroll class="thar-right-collection-sec">
    <div class="tharCollectionright">
      <div class="tharCollectionrightinner">
        <div
          class="tharCollectionrightbg"
          :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
        >
          <div class="tharCollectionrightscroll">
            <h2 class="tharCollectionrightscrolltext">
              <span>{{ shopifyData.secTitle }}</span>
              <span>{{ shopifyData.secBottomTitle }}</span>
            </h2>
          </div>
        </div>
      </div>
      <div>
        <div class="tharCollectionrightscrollres">
          <h2 class="tharCollectionrightscrolltextres">
            <span>{{ shopifyData.secTitle }}</span>
            <span>{{ shopifyData.secBottomTitle }}</span>
          </h2>
        </div>
        <div class="tharCollectionrightproducts">
          <div />

          <div class="tharCollectionrightinnergrid tharProducts">
            <div v-for="(value, key) in shopifyData.productData" :key="key" class="grid_item">
              <a
                v-if="value.showCollection == 'true'"
                :href="value.collectionLink"
                class="product_link collection"
              >
                <div
                  class="tharProductInfo"
                  :class="value.showPreview === 'true' ? 'customImage' : ''"
                >
                  <h2 class="tharProductTitle">{{ value.product.productTitle }}</h2>
                  <div class="tharProductPriceInfo">
                    <span
                      v-if="value.product.compare_at_price > value.product.productidPrice"
                      class="tharProductPrice"
                    >
                      <del>
                        {{ currencySymbol }}
                        {{ value.product.compare_at_price }}
                      </del>
                    </span>
                    <span v-if="value.product.productidPrice" class="tharProductPrice">
                      {{ currencySymbol }}
                      {{ value.product.productidPrice }}
                    </span>
                    <span
                      v-if="value.product.compare_at_price > value.product.productidPrice"
                      class="discountPercentage tharProductPrice"
                    >
                      {{ value.product.discount_percentage }}
                    </span>
                  </div>
                </div>
                <div class="grid_item_img">
                  <img
                    v-lazy="
                      value.showPreview == 'true'
                        ? value.previewimage
                        : value.product.productidImage
                    "
                    :alt="value.showPreview === 'true' ? 'Preview Image' : 'Product Image'"
                    loading="lazy"
                    aria-hidden="true"
                    aria-label="Product Image"
                    width=""
                    height=""
                  />
                </div>
              </a>

              <a
                v-else
                :href="value.product.productUrl"
                :product-id="value.product.productid"
                class="product_link"
              >
                <div
                  class="tharProductInfo"
                  :class="value.showPreview === 'true' ? 'customImage' : ''"
                >
                  <h2 class="tharProductTitle">{{ value.product.productTitle }}</h2>
                  <div class="tharProductPriceInfo">
                    <span v-if="value.product.compare_at_price > '1'" class="tharProductPrice">
                      <del>
                        {{ currencySymbol }}
                        {{ value.product.compare_at_price }}
                      </del>
                    </span>
                    <span v-if="value.product.productidPrice" class="tharProductPrice">
                      {{ currencySymbol }}
                      {{ value.product.productidPrice }}
                    </span>
                    <span
                      v-if="value.product.compare_at_price > '1'"
                      class="discountPercentage tharProductPrice"
                    >
                      {{ value.product.discount_percentage }}
                    </span>
                  </div>
                </div>
                <div class="grid_item_img">
                  <img
                    v-lazy="
                      value.showPreview == 'true'
                        ? value.previewimage
                        : value.product.productidImage
                    "
                    :alt="value.showPreview === 'true' ? 'Preview Image' : 'Product Image'"
                    loading="lazy"
                    aria-hidden="true"
                    aria-label="Product Image"
                    width=""
                    height=""
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { currencyJson } from '@/currency';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
    };
  },
  computed: {
    backgroundImage() {
      return this.windowWidth <= 768 ? this.shopifyData.mobBg : this.shopifyData.desktopBg;
    },
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener('resize', this.handleResize);

    gsap.registerPlugin(ScrollTrigger);
    const mm = gsap.matchMedia();

    mm.add('(min-width: 769px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.tharCollectionrightinner',
            scrub: 2,
            start: 'top bottom',
            end: '100% center',
            // markers: true
          },
        })
        .to(
          '.tharCollectionrightinner',
          {
            position: 'sticky',
            top: 0,
          },
          'b'
        )
        .to(
          '.tharCollectionrightscroll',
          {
            xPercent: -50,
          },
          'b'
        );
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.tharProductTitle,
.tharProductPrice {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 12.08px;
  font-weight: 400;
  line-height: 10.99px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #000;
}

.tharProductPriceInfo {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.discountPercentage {
  color: red;
}

.tharProductPrice {
  font-weight: 700;
}

.tharProductInfo.customImage * {
  color: #ffff;
}

.tharProductInfo.customImage .discountPercentage {
  color: red;
}

.tharProductInfo.customImage .tharProductPrice del {
  color: grey;
}

.tharProducts .grid_item {
  position: relative;
}

.grid_item .tharProductInfo {
  position: absolute;
  bottom: 12px;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.tharCollectionrightscrolltext {
  max-width: 320px;
  width: 100%;
  margin: 30px 96px 0 0;
}

.tharCollectionrightscrolltext span {
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 18.2px;
  text-transform: uppercase;
  text-align: right;
  display: block;
}

.tharCollectionrightinnergrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: #f0f1f4;
}

.tharCollectionrightinnergrid img {
  width: 100%;
  height: 100%;
  display: block;
}

.tharCollectionrightinner {
  position: relative;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.tharCollectionrightbg {
  height: 100vh;
  width: 100%;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
}

.tharCollectionrightproducts {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  position: relative;
  z-index: 4;
}

.tharCollectionrightscroll {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  text-align: center;
  height: 100vh;
  margin: 0 auto;
}

.tharCollectionrightscrolltextres {
  display: none;
}

@media screen and (max-width: 1024px) {
  .tharCollectionrightscrolltext {
    margin: 30px 25px 0 0;
  }
}

@media only screen and (max-width: 768px) {
  .tharCollectionrightbg {
    width: 100%;
    max-width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
  }

  .tharCollectionrightscrolltext {
    margin: 0px;
  }

  .tharCollectionrightscroll {
    text-align: center;
    align-items: center;
    display: none;
  }

  .tharCollectionrightinner {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .tharCollectionrightproducts {
    grid-template-columns: 0% 100%;
  }

  .tharCollectionrightinnergrid {
    width: 100%;
  }

  .tharCollectionrightscrolltextres {
    display: block;
    /* font-family: Neue Haas Grotesk Display Pro; */
    max-width: 320px;
    width: 100%;
    padding: 20px 0;
  }

  .tharCollectionrightscrolltextres span {
    font-size: 14px;
    font-weight: 400;
    line-height: 18.2px;
    color: #ffffff;
    text-align: center;
    text-transform: uppercase;
    display: block;
  }

  .tharCollectionrightscrollres {
    position: -webkit-sticky;
    position: sticky;
    top: 0%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tharProductTitle,
  .tharProductPrice {
    font-size: 8px;
    line-height: 1;
    letter-spacing: 0.01em;
  }

  .grid_item .tharProductInfo {
    bottom: 2px;
    left: 2px;
    padding: 5px;
  }
}
</style>
